import { Box } from "@/src/components/Box";
import { OrderData } from "@/src/components/OrderData";

export function KeyValue(props: any) {
  return (
    <Box className={"rounded bg-super-light-gray"}>
      <OrderData {...props} />
    </Box>
  );
}
